import { RemoteReceiver, RemoteChannel } from '@remote-ui/core'
import { ActionArgumentMap } from '@remote-ui/core/src/types'

type Subscriber = (type: keyof ActionArgumentMap, ...payload: Array<any>) => void

const getRemoteChannel = (receiver: RemoteReceiver) => {
	let subscribersCounter = 0
	const subscribers: Record<number, Subscriber> = {}
	const channel: RemoteChannel = (type, ...payload) => {
		Object.values(subscribers).forEach((callback) => callback(type, ...payload))

		return receiver.receive(type, ...payload)
	}

	const subscribe = (callback: Subscriber) => {
		const subscriberId = subscribersCounter++
		subscribers[subscriberId] = callback

		return () => {
			delete subscribers[subscriberId]
		}
	}

	return { channel, subscribe }
}

export default getRemoteChannel
